<template>
  <CContainer fluid>
    <div class="metro-menu">
      <div 
        class="tile tile-1 small" 
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/campanias` })">
        <i class="bi bi-rocket-takeoff"></i>
        <span>Campa&ntilde;as</span>
      </div>
      <div 
        class="tile tile-2 small bg-s3turquoise" 
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/prospectos` })">
        <i class="bi bi-person-exclamation"></i>
        <span>Prospectos</span>
      </div>
      <div 
        class="tile tile-3 small"
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/oportunidades` })">
        <i class="bi bi-graph-up-arrow"></i>
        <span>Oportunidades</span></div>
      <div 
        class="tile small bg-s3orange"
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/seguimientos` })">
        <i class="bi bi-chat-square-text"></i>
        <span>Seguimientos</span>
      </div>
      <div 
        class="tile small bg-s3lime"
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/calendarioactividades` })">
        <i class="bi bi-calendar3"></i>
        <span>Calendario Actividades</span>
      </div>
      <div 
        class="tile small bg-s3rose"
        @click="$router.push({ path: `/${rootPath}/coming-soon` })">
        <i class="bi bi-bell"></i>
        <span>Notificaciones</span>
      </div>
      <a href="#" @click="$router.push({ path: '/sinacceso'})">
        <span>Accesso Denegado</span>
      </a>
    </div>
  </CContainer>
</template>

<style scoped>
  @import "../../../assets/css/metro-menu.css";
</style>

<script>
  export default {
    name: "MarketingMenu",
    components: {

    },
    data() {
      return {
        rootPath: ""
      }
    },
    methods: {

    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath.split("/")[1];

      console.log(this.rootPath);
    },
    beforeDestroy() {
      
    }
  }
</script>
